<dx-popup
   [width]="'500'"
   [height]="'500'"
   [showTitle]="true"
   [title]="'Profilo stampante'"
   [dragEnabled]="false"
   (onShowing)="fetchProfiliStampanti()"
   [hideOnOutsideClick]="false"
   [showCloseButton]="true"
   (onHiding)="closePrintModal()"
   [copyRootClassesToWrapper]="true"
   class="app-dx-dialog"
   [(visible)]="popupProfiloStampa">

   <div class="app-dialog-wrapper">
      <form [formGroup]="form" class="grid grid-cols-12 p-4 app-dialog-content pb-10 with-label form-modal">
         <div class="col-span-12">
            <mat-label>Preferenza stampa etichette</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <mat-select formControlName="profilo">
                  <mat-option [value]="0">Seleziona una preferenza...</mat-option>
                  <mat-option *ngFor="let profilo of profiliStampanti" [value]="profilo.id">
                     {{profilo.display_name}}
                  </mat-option>
               </mat-select>
            </mat-form-field>
         </div>

         <div class="col-span-12 mb-3">
            <mat-checkbox #defaultStampa class="mr-3" color="primary">Imposta come preferenza di default per le stampe future</mat-checkbox>
         </div>

         <div class="col-span-12">
            <mat-label>N° Etichette da saltare (etichette vuote)</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="number" formControlName="n_skip">
            </mat-form-field>
         </div>

         <div class="col-span-12" *ngIf="isSingle">
            <mat-label>N° Etichette da stampare (N° max: {{maxEtichette}})</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="number" formControlName="n_print">
            </mat-form-field>
         </div>
      </form>

      <div class="grid grid-cols-2 h-[70px]">
         <div></div>
         <button [disabled]="form.get('profilo')?.value == 0 || form.get('n_print')?.value > maxEtichette"
                 class="ds-btn ds-btn-info w-full h-full"
                 (click)="outputPrint(defaultStampa)">
            Stampa
         </button>
      </div>

   </div>

</dx-popup>
